/*******************************************************************************
 *                                                                             *
 * WARNING! This file was automatically generated from the server-side model!  *
 * You shouldn't edit this by hand.  If you want to modify the client-side     *
 * model behavior, you should modify: ../ModelEdiCrossRefRevenueCode.ts        *
 *                                                                             *
/*******************************************************************************/

import { Endpoint, ModelRow, RowConstructor } from "@mcleod/core";

const endpointPath = "lme/datafusion/edi-cross-ref-revenue-code";

export class AutogenModelEdiCrossRefRevenueCode<RowType extends ModelRow> extends Endpoint<RowType, RowEdiCrossRefRevenueCodeFields> {
	constructor(ctor: RowConstructor) {
		super(endpointPath, ctor);
	}
}

export class AutogenRowEdiCrossRefRevenueCode extends ModelRow<RowEdiCrossRefRevenueCodeFields> {
	constructor(values?: Partial<RowEdiCrossRefRevenueCodeFields>) {
		super(endpointPath, true, values);
	}
}

export interface RowEdiCrossRefRevenueCodeFields {
	company_id: string;
	edi_code: string;
	equipment_type_id: string;
	fgi_packaging_type_code: string;
	hdr_uid: number;
	id: string;
	la_business_unit: string;
	order_type_id: string;
	partner_id: string;
	"revenue_code.company_id": string;
	"revenue_code.descr": string;
	"revenue_code.expense_glid": string;
	"revenue_code.id": string;
	"revenue_code.order_mode": string;
	"revenue_code.revenue_glid": string;
	revenue_code_id: string;
	revenue_description: string;
	seg_alloc_code: string;
	version: string;
}

